import React, { useRef } from 'react';
import { useAtomValue } from 'jotai';

import { languageAtom } from '@shared/store/slice-atoms';
import ReactPlayer from 'react-player';

import styles from '../styles/Video.module.css';
import { defaultBannerConfig } from '@shared/config/constants/Banners';
import { getVideoBannerUrl } from '@shared/utils';

const Video = ({ useEn = false, bannerConfing = defaultBannerConfig }) => {
  const language = useAtomValue(languageAtom);

  const videoRef = useRef(null);

  const locale = useEn ? 'en' : language.locale;

  let videoSrc = getVideoBannerUrl(bannerConfing, locale);

  const isVimeoRoute = window.location.pathname === '/vimeo';

  return (
    <section className={styles.landingVideoSection}>
      <div className={styles.landingVideo}>
        {isVimeoRoute ? (
          <iframe
            src="https://player.vimeo.com/video/619711680?title=0&byline=0&muted=1&autoplay=1&loop=1&controls=0&sidedock=0"
            width="500"
            height="280"
            frameBorder="0"
            title="vimeo"
          />
        ) : (
          <ReactPlayer
            ref={videoRef}
            url={videoSrc}
            playing
            loop
            volume={0}
            muted
            playsinline
            width="100%"
            height="100%"
          />
        )}
      </div>
    </section>
  );
};

export { Video };
